const Data = [
    {
        "name": "Megha Singhal",
        "position":"LiGHT Head",
        "imageUrl": "/assets/images/members/Heads24/MeghaSinghal.jpg",
        "facebookLink": "https://www.facebook.com/megha.singhal.35325/",
        "linkedinLink": "https://www.linkedin.com/in/megha-singhal-7a9a3926a/",
        "email": "megha.singhal@gyws.org"
    },
    {
        "name": "Ayush Gurjar",
        "position":"LiGHT Head",
        "imageUrl": "/assets/images/members/Heads24/AyushGurjar.jpg",
        "facebookLink": "",
        "linkedinLink": "https://www.linkedin.com/in/ayush0206",
        "email": "ayush.gurjar@gyws.org"
    },
    {
        "name": "Samshritha Bura",
        "position":"LiGHT Head",
        "imageUrl": "/assets/images/members/Heads24/SamshrithaBura.jpeg",
        "facebookLink": "https://m.facebook.com/profile.php?id=100087910621138",
        "linkedinLink": "https://www.linkedin.com/in/samshritha-bura-116136258/",
        "email": "samshritha.bura@gyws.org"
    },
    {
        "name": "Ahmad Raza Khan",
        "position":"LiGHT Head",
        "imageUrl": "/assets/images/members/Heads24/AhmadKhan.jpeg",
        "facebookLink": "https://www.facebook.com/profile.php?id=100086032638585",
        "linkedinLink": "www.linkedin.com/in/ahmadrazakhan92",
        "email": "ahmad.khan@gyws.org"
    },
    {
        "name": "Vidit Om",
        "position":"LiGHT Head",
        "imageUrl": "/assets/images/members/Heads24/ViditOm.jpg",
        "facebookLink": "https://www.facebook.com/people/Vidit-Om/pfbid02C29CxeZZA6F135ehhaPZjKZWUnEY2zwPi4uRhhFeEtpg7e8PBGCaAynvsEb8N4GYl/?sk=about",
        "linkedinLink": "https://www.linkedin.com/in/vidit-om-b11885256/",
        "email": "vidit.om@gyws.org"
    },
    {
        "name": "Saryu Gosika",
        "position":"LiGHT Head",
        "imageUrl": "/images/profile.png",
    }
   
]

export default Data;